import React from "react";
import PortalLogin from "@/components/PortalLoginShared";
export default function ApplicantLogin() { return <PortalLogin portalType="applicant" />; }
